import {cn} from "@/lib/utils";

interface CardTitleProps {
    title: React.ReactNode;
    className?: string;
    backgroundImgSrc?: string;
}

function toBackgroundImageUrl(src: string) {
    const encoded = src.split("/").map((segment) => encodeURIComponent(segment)).join("/");
    return `url("${encoded}")`;
}

export default function CardTitle({ title, className, backgroundImgSrc }: CardTitleProps) {
    return (
        <div className={cn("relative h-[330px] flex justify-center items-center bg-slate-700", className)}>
            {backgroundImgSrc && (
                <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                    style={{ backgroundImage: toBackgroundImageUrl(backgroundImgSrc) }}
                />
            )}
            <div className="absolute inset-0 bg-black/50" />
            <h2 className="text-white font-bold text-3xl p-4 relative z-10 text-center">{title}</h2>
        </div>
    );
}
